import { Mutable } from './types';

// Todo: Update to new values
/** Color mapping following figma. Duplicate colors differ by 1 */
const COLORS = {
  neutral: {
    n0: '#FFFFFF',
    n50: '#FAFBFD',
    n75: '#F9FAFC',
    /** hover color  */
    n100: '#F5F7FB',
    n200: '#EDEFF4',
    n300: '#E6E8F0',
    n400: '#D8DAE5',
    n500: '#C1C4D6',
    n600: '#8F95B2',
    n700: '#696F8C',
    /** Text-default */
    n800: '#474D66',
    /** #101840 */
    n900: '#101840',
    /** #1B203A */
    n901: '#1B203A',
    /* Primary Palette/Black */
    n902: '#161A30',
    /** Beam Texts/default */
    n903: '#1A1B1C',
  },
  blue: {
    b50: '#F3F6FF',
    b100: '#E6EDFF',
    b200: '#D6E0FF',
    b300: '#9DB5FF',
    /** #3366FF */
    b400: '#3366FF',
    /** #1371FE */
    b401: '#1371FE',
    b500: '#2952CC',
    b600: '#1F3D99',
  },
  green: {
    g50: '#F5FBF8',
    g100: '#EEF8F4',
    g200: '#DCF2EA',
    g300: '#A3E6CD',
    g400: '#52BD94',
    g500: '#429777',
    g600: '#317159',
  },
  yellow: {
    y50: '#FFF6EB',
    y100: '#FFEFD2',
    y200: '#FFDFA6',
    y300: '#FFD079',
    /**  #FFB020,  */
    y400: '#FFB020',
    /** AKA orange/warning FF9900,  */
    y401: '#FF9900',
    y500: '#996A13',
    y600: '#66460D',
  },
  red: {
    r50: '#FDF4F4',
    r100: '#F9DADA',
    r200: '#F4B6B6',
    r300: '#EE9191',
    r400: '#D14343',
    r500: '#A73636',
    r600: '#7D2828',
  },
  violet: {
    v50: '#F8F7FD',
    v100: '#E7E4F9',
    v200: '#D0CAF4',
    v300: '#B8AFEE',
    v400: '#897AE3',
    v500: '#6E62B6',
    v600: '#524988',
  },
  teal: {
    t50: '#F2FCFD',
    t100: '#D3F5F7',
    t200: '#A8EAEF',
    t300: '#7CE0E6',
    t400: '#25CBD6',
    t500: '#10899E',
    t600: '#0F5156',
  },
  pink: {
    p50: '#FEF5FB',
    p100: '#FBDDF3',
    p200: '#F8BBE7',
    p300: '#F499DA',
    p400: '#ED55C2',
    p500: '#BE449B',
    p600: '#8E3374',
  },
  orange: {
    o50: '#FDF4F4',
    o100: '#F8E3DA',
    o200: '#F2C8B6',
    o300: '#EBAC91',
    o400: '#DE7548',
    o500: '#B25E3A',
    o600: '#85462B',
  },
} as const;

export type T_COLORS = Mutable<typeof COLORS>;

export default COLORS as T_COLORS;
